<template>
  <a-modal v-model:visible="visible" title="导出失败" :after-close="onClose">
    <div class="px-8">
      <div class="mt-2 opacity-90 text-center">
        <div class="text-lg font-semibold">bin文件过大</div>
        <div class="opacity-70 mt-2">
          表盘bin体积为{{ binSize }}kb，超过{{ maxBinLimit }}kb，无法导出。
        </div>
      </div>
      <div class="mt-2.5 pl-2 opacity-70">
        <div class="">可通过如下方式优化：</div>
        <div>1. 减少样式数量;</div>
        <div>2. 减少配色数量;</div>
        <div>3. 减少图层数量；</div>
        <div>4. 减少图片体积；</div>
      </div>
    </div>

    <template #footer>
      <a-button key="back" @click="close">知道了</a-button>
    </template>
  </a-modal>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

const visible = ref(false);

const maxBinLimit = ref(0);
const binSize = ref(0);

defineExpose({
  open: (_binSize: number, _maxBinLimit: number) => {
    maxBinLimit.value = _maxBinLimit;
    binSize.value = _binSize;
    visible.value = true;
  }
});

const close = () => {
  visible.value = false;
};
const onClose = () => {
  maxBinLimit.value = 0;
  binSize.value = 0;
};
</script>
